var exports = {
  "zr": "x93eb46d8--75b325--root",
  "Lb": "x93eb46d8--75b325--carousel-container",
  "Dk": "x93eb46d8--75b325--carousel",
  "Y": "x93eb46d8--75b325--carousel--compact",
  "Qs": "x93eb46d8--75b325--content",
  "WD": "x93eb46d8--75b325--labels",
  "O0": "x93eb46d8--75b325--rating",
  "Bf": "x93eb46d8--75b325--modal-controls",
  "s$": "x93eb46d8--75b325--carousel-controls",
  "Y3": "x93eb46d8--75b325--buttons-container",
  "hl": "x93eb46d8--75b325--address",
};

module.exports = exports;
